import React from "react";
import Slider from "react-slick";

import "../../../../css/slick.css";
import "../../../../css/slick-theme.css";
import RecommendationsProgramsItem from "./RecommendationsProgramsItem";

import { isInfinite } from '../../../../helpers/recoHelper';
import { getCurrentSlickRange } from "../../../../helpers/helper";
import { trackEvent } from "../../../../helpers/analyticsHelper";
import { PAGE_EVENT_NAMES } from "../../../../constants/common";

export default class RecommendationsPrograms extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            activeSlide: 0
        }
    }
    
    learnMoreClickHandler(recoId, link){
        window.open(link);
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
            recoId : recoId,
            ctaClicked : link
        })
    }
    render(){
        const props = this.props;
        const recoPrograms = props.recoPrograms;
        const totalRecos = recoPrograms.unviewedRecommendationWrapperList.length + recoPrograms.viewedRecommendationWrapperList.length;
        const showDots = ( totalRecos < props.configs["DASHBOARD.RECOMMENDATIONS.SLICK_DOTS_LIMIT"]);
        const recoSliderSettings = {	
            className: "center",	
            centerPadding: "0",	
            centerMode: showDots,	
            infinite: showDots && isInfinite(recoPrograms, 3),
            adaptiveHeight: true,
            slidesToShow: 3,	
            slidesToScroll: 1,	
            speed: 500,
            dots: showDots,
            afterChange: current => this.setState({ activeSlide: current }),
            responsive: [
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 2,
                    infinite: showDots && isInfinite(recoPrograms, 2)
                  },
                },
                {
                  breakpoint: 550,
                  settings: {
                    slidesToShow: 1,
                    infinite: showDots && isInfinite(recoPrograms, 1)
                  }
                },
            ]
        };
    
        return (
            <>
                {recoPrograms && (recoPrograms.unviewedRecommendationWrapperList.length > 0 || recoPrograms.viewedRecommendationWrapperList.length > 0) && (
                    <>
                        <p className="recommendations-title">
                            {props.translations["RECOMMENDATIONS.PROGRAMS.TITLE"]}
                        </p>
                        <div className="recommendations-programs">
                            <Slider ref={slider => (this.slider = slider)} {...recoSliderSettings} >
                                {recoPrograms.unviewedRecommendationWrapperList.length > 0 && recoPrograms.unviewedRecommendationWrapperList.map((item, index) => (
                                    item && <RecommendationsProgramsItem item={item} key={index} recoInsightsEnabled={props.recoInsightsEnabled} insightBulbImage={props.insightBulbImage} onHoverRecos={(id, type) => this.props.onHoverRecos(id, type)} learnMoreClickHandler={(recoId, link)=>this.learnMoreClickHandler(recoId, link)}/>
                                ))}
                                {recoPrograms.viewedRecommendationWrapperList.length > 0 && recoPrograms.viewedRecommendationWrapperList.map((item, index) => (
                                    item && <RecommendationsProgramsItem item={item} key={index} recoInsightsEnabled={props.recoInsightsEnabled} insightBulbImage={props.insightBulbImage} onHoverRecos={(id, type) => this.props.onHoverRecos(id, type)} learnMoreClickHandler={(recoId, link)=>this.learnMoreClickHandler(recoId, link)}/>
                                ))}
                            </Slider>
                            {
                                !showDots && 
                                <div className="custom-paging">
                                    {props.translations["DASHBOARD.RECOMMENDATION.SLICK_TEXT1"]} <span className="custom-paging-range">{getCurrentSlickRange(this.state.activeSlide)}</span> {props.translations["DASHBOARD.RECOMMENDATION.SLICK_TEXT2"]} {totalRecos}
                                </div>
                            }
                        </div>
                    </>
                )}
            </>
        )    
    }
}